require('./scheduledTransfersFilters.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { getLanguage } = require('core/i18n').i18n;
const { formatCurrency } = require('utilities/currencyHelper');
const { AmountFilter } = require('commonsComponents/amountFilter');
const CurrencyDropdown = require('components/transfers/currencyDropdown/currencyDropdown');
const OKModal = require('components/commons/OKModal/OKModal');
// @ constants
const { EURO_TEXT } = require('constants/index');
const { AMOUNT_FILTER_LABEL, AMOUNT_FILTER_GREATER_THAN, AMOUNT_FILTER_LOWER_THAN } = require('constants/commonsComponents');

class ScheduledTransfersFilters extends React.Component {
    constructor(props) {
        super(props);

        const { immFilter } = props;

        this.state = {
            amountFrom: immFilter.getIn(['amount', 'from', 'amount']),
            amountTo: immFilter.getIn(['amount', 'to', 'amount']),
            currency: immFilter.getIn(['currency', 'value']) || EURO_TEXT
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeAmountMin = this.handleChangeAmountMin.bind(this);
        this.handleChangeAmountMax = this.handleChangeAmountMax.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    }

    handleChangeAmountMax(amountTo) {
        this.setState({
            amountTo
        });
    }

    handleChangeAmountMin(amountFrom) {
        this.setState({
            amountFrom
        });
    }

    handleCurrencyChange(currency) {
        this.setState({
            currency: currency.value
        });
    }

    handleFormSubmit(event) {
        event.preventDefault();

        const { onSetFilters, onCloseClick, accountCurrency } = this.props;
        const { amountFrom, amountTo, currency } = this.state;
        const selectedCurrency = currency || accountCurrency;

        onSetFilters({
            amount: {
                from: {
                    currency: selectedCurrency,
                    amount: amountFrom
                },
                to: {
                    currency: selectedCurrency,
                    amount: amountTo
                }
            },
            currency: {
                value: selectedCurrency
            }
        });

        onCloseClick();
    }

    render() {
        const { accountCurrency, immFilter, isOpen, onCloseClick } = this.props;
        const { amountFrom, amountTo, currency } = this.state;
        const selectedCurrency = currency || accountCurrency;

        const content = (
            <section className="scheduled-transfers-filters">
                <fieldset>
                    <AmountFilter
                        immFilter={immFilter}
                        onChangeMin={this.handleChangeAmountMin}
                        onChangeMax={this.handleChangeAmountMax}
                        fromValue={amountFrom}
                        toValue={amountTo}
                        currencySymbol={formatCurrency(selectedCurrency)}
                        amountLabel={AMOUNT_FILTER_LABEL}
                        greaterThan={AMOUNT_FILTER_GREATER_THAN}
                        lowerThan={AMOUNT_FILTER_LOWER_THAN}
                        language={getLanguage()}
                    />
                </fieldset>
                <fieldset>
                    <CurrencyDropdown
                        value={currency}
                        onChange={this.handleCurrencyChange}
                        openUp={true}
                    />
                </fieldset>
            </section>
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="transfersScheduled-apply"
                secondaryButtonText="transfersScheduled-cancel"
                title="transfersScheduled-filterScheduledTransfers"
                type="filter"
            />
        );
    }
}

ScheduledTransfersFilters.propTypes = {
    accountCurrency: PropTypes.string,
    immFilter: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onSetFilters: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired
}

ScheduledTransfersFilters.defaultProps = {
    accountCurrency: EURO_TEXT
}

module.exports = ScheduledTransfersFilters;
